import { Box, Typography, Button } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Login from "./Login";
import theme from "../theme/theme";
import MenuBar from "../components/layout/MenuBar";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

const Home = () => {
    const [openLogin, setOpenLogin] = useState(false);
    const [cameFromUnauthorized, setCameFromUnauthorized] = useState(false);

    const handleCloseLogin = () => setOpenLogin(false);

    const location = useLocation();
    const navigate = useNavigate();

    const handleOpenLogin = () => {
        if (cameFromUnauthorized) {
            navigate('/unauthorized');
            return;
        }

        setOpenLogin(true);
    };

    const { user } = useAppContext();
    const isLoggedIn = !!user;

    useEffect(() => {
        if (location?.state?.fromUnauthorized) {
            setCameFromUnauthorized(true);
            // clear the history state so this only affects the first visit
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location, navigate]);

    return (
        <Box sx={{ display: "flex", px: 3, minHeight: "100vh" }}>
            {isLoggedIn && (
                <Box sx={{ width: "25%", mt: 4 }}>
                    <MenuBar />
                </Box>
            )}

            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    p: 2,
                }}
            >

                {isLoggedIn ? (
                    <Box sx={{ textAlign: "center" }}>

                        <Typography
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 900,
                                fontSize: "6rem",
                                mt: "-40px",
                                letterSpacing: "1px",
                                textTransform: "none",

                                background: "linear-gradient(45deg, orange, green)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",

                                textShadow: "4px 4px 8px rgba(0,0,0,0.15)",
                            }}
                        >
                            <span style={{ fontSize: "5rem" }}>W</span>
                            <span style={{ fontSize: "5rem" }}>elcome</span>
                        </Typography>



                        <Typography
                            sx={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 700,
                                fontSize: "4rem",


                                letterSpacing: "1px",
                                textTransform: "none",

                                background: "linear-gradient(45deg, green,orange)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",

                                textShadow: "2px 2px 6px rgba(0,0,0,0.12)",
                            }}
                        >
                            <span style={{ fontSize: "4.5rem" }}>T</span>
                            <span style={{ fontSize: "4.5rem" }}>o Reward Application..</span>
                        </Typography>
                    </Box>

                ) : (
                    <>
                        {/* LOCK ICON BOX */}
                        <Box
                            sx={{
                                width: 200,
                                height: 200,
                                borderRadius: "50%",
                                backgroundColor: "rgba(255,144,22,0.12)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 2,
                            }}
                        >
                            <LockOpenIcon sx={{ fontSize: 100, color: "#ff8c00" }} />
                        </Box>

                        <Typography
                            sx={{
                                mb: 3,

                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 800,
                                fontSize: "3rem",

                                letterSpacing: "1px",

                                background: "linear-gradient(45deg, green, orange)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",

                                textShadow: "2px 2px 6px rgba(0,0,0,0.12)",
                            }}
                        >
                            Please login to access the application...
                        </Typography>


                        <Button
                            variant="contained"
                            onClick={handleOpenLogin}
                            sx={{ fontSize: "1rem", padding: "8px 30px" }}
                        >
                            LOGIN
                        </Button>

                        <Login open={openLogin} onClose={handleCloseLogin} />
                    </>
                )}

            </Box>

        </Box>
    );
};
export default Home;
